import axios from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'
/**
 * Get likes and dislikes for a piece of content
 *
 */
export const getLikesDislikes = async ({ contentId }) => {
  return axios.get(`${serviceBaseUrl}/sessions/${contentId}/ratings`)
}

/**
 * Update and re-retrieve likes /dislikes
 *
 */
export const updateLikesDislikes = async ({ cmsSessionId, method }) => {
  if (method === 'PUT' || method === 'DELETE') {
    return axios
      .put(`${serviceBaseUrl}/guests/CURRENT/sessions/${cmsSessionId}/ratings?rating=${method === 'PUT' ? '1' : '-1'}`)
      .then(() => {
        return getLikesDislikes({ contentId: cmsSessionId })
      })
  }
  return getLikesDislikes({ contentId: cmsSessionId })
}
